import React, { Component } from "react"
import "./index.css"
import VarietyShowSlider from "./Variety-Show-Slider"

class VarietyShowSection extends Component {
  render() {
    return (
      <section id="variety-show-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 p-0 variety-show-slider-wrapper">
              <VarietyShowSlider />
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center mt-auto home-hero-btn-group">
              <button className="btn die-show-btn">DIE SHOW</button>
              <button className="btn tickets-btn">TICKETS</button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default VarietyShowSection
